import {
    Component,
    OnInit,
    Input,
    OnDestroy,
    ViewChild,
    Output,
    EventEmitter,
    ElementRef,
    ChangeDetectorRef,
    ViewChildren,
} from "@angular/core";
import { BaseComponent } from "../../Library/BaseComponent";
import {
    ComplainRegister,
    ComplainSearch,
    RecurrenceFilterModel,
    CurrentReservationSearch,
    Glitch_SearchRequest, RecurrenceQuery,
} from "../../Models/RequestModels";
import { MasterDataService } from "../../Services/MasterDataService";
import { ActivatedRoute, Router } from "@angular/router";
import {
    CallStatuses,
    EntityCodes,
    FilterTypes,
    ModuleLicenceCodes,
} from "../../Models/EnumModels";
import { PMSService } from "../../Services/PMSService";
import * as _ from "lodash";
import { ComplainService } from "../../Services/ComplainService";
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
    LocationLookup,
    GenericMaster,
    CallDescriptionLookup,
    CallCategoryLookup,
    VIP,
    GenericMaster_String,
    GlitchCategory,
    GlitchDescription,
} from "../../Models/GlobalEntities";
import { NgSelectComponent } from "@ng-select/ng-select";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { NgModel } from "@angular/forms";

@Component({
    selector: "JobFilterInner",
    templateUrl: "./JobFilterInner.html",
})
export class JobFilterInner extends BaseComponent implements OnInit {
    ModalRef: NgbModalRef;

    RequestModel: any = {};

    @ViewChild("cmbCallDescriptions") cmbCallDescriptions: NgSelectComponent;

    @ViewChild("cmbLocations") cmbLocations: NgSelectComponent;
    @ViewChild("cmbCallCategories") cmbCallCategories: NgSelectComponent;
    @ViewChild("cmbDept") cmbDept: NgSelectComponent;
    @ViewChild("cmbAssignedTo") cmbAssignedTo: NgSelectComponent;
    @ViewChild("cmbTaggedStaffIds") cmbTaggedStaffIds: NgSelectComponent;

    @ViewChild("cmbRequestBy") cmbRequestBy: NgSelectComponent;
    @ViewChild("cmbLoggedBy") cmbLoggedBy: NgSelectComponent;
    @ViewChild("cmbSections") cmbSections: NgSelectComponent;
    @ViewChild("cmbVIPCodes") cmbVIPCodes: NgSelectComponent;
    @ViewChild("cmbPriority") cmbPriority: NgSelectComponent;
    @ViewChild("cmbGlitchCategories") cmbGlitchCategories: NgSelectComponent;
    @ViewChild("cmbGlitchDescriptions")
    cmbGlitchDescriptions: NgSelectComponent;
    @ViewChild("cmbGlitchStaffs") cmbGlitchStaffs: NgSelectComponent;
    @ViewChild("cmbRegisteredByStaffs")
    cmbRegisteredByStaffs: NgSelectComponent;
    @ViewChild("cmbInvolvedStaffs")
    cmbInvolvedStaffs: NgSelectComponent;
    @ViewChild("cmbLoggedDate")
    cmbLoggedDate: NgSelectComponent;
    @ViewChild("cmbPax")
    cmbPax: NgSelectComponent;

    lstLocations: Array<LocationLookup> = [];
    lstStaff: Array<GenericMaster> = [];
    lstPriority: Array<GenericMaster> = [];
    lstCallDescriptions: Array<CallDescriptionLookup> = [];
    lstCallCategories: Array<CallCategoryLookup> = [];
    lstDepartments: Array<GenericMaster> = [];
    lstSections: Array<GenericMaster> = [];
    lstVIP: Array<VIP> = [];
    lstGlitchCategories: Array<GlitchCategory> = [];
    lstGlitchDescriptions: Array<GlitchDescription> = [];
    lstGlitchStaffs: Array<GenericMaster> = [];
    lstLoggedByStaffs: Array<GenericMaster> = [];
    lstTaggedStaffs: Array<GenericMaster> = [];
    lstInvolvedStaffs: Array<GenericMaster> = [];
    lstloggedDate: Array<GenericMaster> = [];
    lastPax: Array<any> = [
        {
            Name: "1",
            Id: 1,
        },
        {
            Name: "2",
            Id: 2,
        },
        {
            Name: "3",
            Id: 3,
        },
        {
            Name: "4",
            Id: 4,
        },
        {
            Name: "5",
            Id: 5,
        },
        {
            Name: "6",
            Id: 6,
        },
        {
            Name: "7",
            Id: 7,
        },
        {
            Name: "8",
            Id: 8,
        },
        {
            Name: "9",
            Id: 9,
        },
        {
            Name: "10",
            Id: 10,
        },
    ];

    lstLastProps: Array<number> = [];

    _ModuleLicenceCodes = ModuleLicenceCodes;

    @Output() ApplyFilter = new EventEmitter();

    _FilterTypes = FilterTypes;

    @Input() EnabledFilters: Array<FilterTypes> = [
        FilterTypes.AssignedTo,
        FilterTypes.CallCategory,
        FilterTypes.CallDescription,
        FilterTypes.Dept,
        FilterTypes.Location,
        FilterTypes.IsGuestCall,
        FilterTypes.LoggedBy,
        FilterTypes.ReportedBy,
        FilterTypes.Sections,
        FilterTypes.Vip,
        FilterTypes.HasGlitch,
        FilterTypes.IsKMTCategory,
        FilterTypes.HasAttachment,
        FilterTypes.HasEscalation,
        FilterTypes.TaggedStaffIds,
        FilterTypes.StaffsInvolved,
        FilterTypes.LoggedDate,
        FilterTypes.Priority
    ];

    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
        public route: ActivatedRoute,
        public router: Router,
        public masterService: MasterDataService,
        protected pmsService: PMSService,
        private complainService: ComplainService,
        private modalService: NgbModal,
        private changeDetector: ChangeDetectorRef
    ) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit(): void {
        this.cmbAssignedTo.virtualScroll = true;
        this.cmbTaggedStaffIds.virtualScroll = true;
        this.cmbCallCategories.virtualScroll = true;
        this.cmbCallDescriptions.virtualScroll = true;
        this.cmbDept.virtualScroll = true;
        this.cmbLocations.virtualScroll = true;
        this.cmbLoggedBy.virtualScroll = true;
        this.cmbRequestBy.virtualScroll = true;
        this.cmbSections.virtualScroll = true;
        this.cmbVIPCodes.virtualScroll = true;
        this.cmbPriority.virtualScroll = true;
        this.cmbGlitchCategories.virtualScroll = true;
        this.cmbGlitchDescriptions.virtualScroll = true;
        this.cmbGlitchStaffs.virtualScroll = true;
        this.cmbRegisteredByStaffs.virtualScroll = true;
        this.cmbInvolvedStaffs.virtualScroll = true;
        this.cmbLoggedDate.virtualScroll = true;
        this.cmbPax.virtualScroll = true;
    }

    CFE(checkfor: FilterTypes) {
        if (this.EnabledFilters.findIndex((a) => a == checkfor) >= 0)
            return true;
        else return false;
    }

    onOpen(Model: any): void {
        this.RequestModel = Model;
    }

    selectAll(model: NgModel, type: string) {
        let selected = [];
        switch (type) {
            case "Department": {
                selected = this.lstDepartments.map((item) => item.Id);
                break;
            }
            case "VIP": {
                selected = this.lstVIP.map((item) => item.Code);
                break;
            }
        }
        model.update.emit(selected);
    }

    // deselectAll(model: NgModel) {
    //     model.update.emit([]);
    // }

    onClear(): void {
        let propId = _.cloneDeep(this.RequestModel.Properties);
        if (this.RequestModel instanceof ComplainSearch) {
            this.RequestModel = new ComplainSearch();
        }
        if (this.RequestModel instanceof RecurrenceFilterModel) {
            this.RequestModel = new RecurrenceFilterModel();
        }
        if (this.RequestModel instanceof RecurrenceQuery) {
            this.RequestModel = new RecurrenceQuery();
        }

        if (this.RequestModel instanceof CurrentReservationSearch) {
            this.RequestModel = new CurrentReservationSearch();
        }

        if (this.RequestModel instanceof Glitch_SearchRequest) {
            this.RequestModel = new Glitch_SearchRequest();
        }

        this.RequestModel.SetDefaults && this.RequestModel.SetDefaults();
        this.RequestModel.Properties = propId;
    }

    onClose(): void {
        this.ModalRef.close();
    }

    onFilterApply(): void {
        this.ModalRef.close();
        this.ApplyFilter.emit(this.RequestModel);
    }

    setEndPattern(code: number, value: boolean) {
        if (value) {
            this.RequestModel.lstEndPattern.push(code);
        } else {
            _.pull(this.RequestModel.lstEndPattern, code);
        }
    }
}
